import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgConnected = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 8.26667L5.73333 12L13.7333 4",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgConnected;
